import { useEffect } from 'react'
import { PROOF_STEPS, HIGHLOOP_FAIL } from './proofSteps.js'

/**
 * Preloads all proof step photos and the high-loop fail photo on mount.
 * Fire-and-forget: Image elements are created and discarded; the browser
 * caches the fetched resources. No cleanup is needed because there is
 * nothing to cancel — the images are not attached to the DOM.
 */
export const usePreloadProofPhotos = (): void => {
  useEffect(() => {
    const urls = [...PROOF_STEPS.map(p => p.basePhoto), HIGHLOOP_FAIL.photo]
    for (const url of urls) {
      const img = new Image()
      img.src = url
    }
  }, [])
}
